export type DependencyValues = {
    __typename: 'DependencyValues';
    percentage: number;
    revenue: number | null;
  };
  
  export type ApplicationDependency = {
    __typename: 'ApplicationDependency';
    name: string;
    supportsRevenue: boolean;
    uuid: string;
    value: DependencyValues;
    comment: string;
  };
  
  export type ProductDependency = {
    __typename: 'ProductDependency';
    name: string;
    uuid: string;
    revenue: number;
    applications: ApplicationDependency[];
  };
  
  export type ProductGroupDependency = {
    __typename: 'ProductGroupDependency';
    name: string;
    uuid: string;
    revenue: number;
    applications: ApplicationDependency[];
    products: ProductDependency[];
  };
  
  export type DivisionDependency = {
    __typename: 'DivisionDependency';
    name: string;
    uuid: string;
    revenue: number;
    applications: ApplicationDependency[];
    productGroups: ProductGroupDependency[];
  };
  
  export enum ApplicationType {
    ENTERPRISE = 'ENTERPRISE',
    LOCATIONS = 'LOCATIONS',
  }
  
  export type ITApplication = {
    __typename: 'ITApplication';
    HostingLocationsAsset: string | null;
    HostingLocationsEntity: string | null;
    application: string;
    applicationType: ApplicationType;
    description: string | null;
    drpDate: string | null;
    drpInPlace: boolean | null;
    drpLink: string | null;
    lastDrpTest: string | null;
    mto: number;
    rpo: number;
    rto: number;
    sla: number;
    supportsEmployees: boolean;
    supportsLifeSafety: boolean;
    supportsOther: boolean | null;
    supportsRegulation: boolean;
    supportsReputation: boolean;
    supportsRevenue: boolean;
    uuid: string;
  };
  
  

export type DivisionType = {
    divisions: DivisionDependency[];
  };
  